<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 面包屑 -->
    <div class="Breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('otherPage.p1')}}</el-breadcrumb-item>
        <el-breadcrumb-item @click.native="toUrl(firstNav.url)">{{firstNav.title}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('otherPage.p9')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap clearfix">
        <div class="main">
          <div class="h2">{{dataObj.title}}</div>
          <div class="time"><i class="el-icon-time"></i> <span>{{dataObj.addTime}}</span></div>
          <div v-html="dataObj.detail" class="ql-editor"></div>
          <div class="share">
            <span>{{$t('otherPage.p11')}}</span>
            <SocialShare v-if="setTimeShare" :config="config"></SocialShare>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getShowHd} from "@/api"
  // import {getActivityA1Detail} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import SocialShare from 'vue-social-share';
  import 'vue-social-share/dist/client.css'
  import 'vue-social-share/dist/vue-social-share.js'
  import {mixin} from '@/mixin/index.js';

  export default {
    name: "Detail",
    mixins:[mixin],
    components: {
      Header,
      Footer,
      Banner,
      SocialShare
    },
    data(){
      return{
        // 详情数据
        dataObj : {},
        // 延时显示分享
        setTimeShare: false,
        // 分享的配置
        config: {
          // // url: "", // 网址，默认使用 window.location.href
          // source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
          // title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
          // description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
          // image: "", // 图片, 默认取网页中第一个img标签
          // sites: [
          //   "qzone",
          //   "qq",
          //   "weibo",
          //   "wechat",
          //   "douban",
          //   "tencent",
          //   "linkedin",
          //   "google",
          //   "facebook",
          //   "twitter",
          // ], // 启用的站点
          // // disabled: ["google", "facebook", "twitter"], // 禁用的站
          sites: ['weibo', 'qq', 'wechat', 'douban', 'qzone'],
          wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
        },
        // 一级Nav
        firstNav: {},
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        // 更新静态数据(后退)
        this.$router.go(-1);
      }
    },
    created(){
      // 设置背景颜色
      document.body.style.backgroundColor = "#f6f8fa"
      // 获取数据
      this.toGetData()
      // 解决默认加载不显示分享
      setTimeout(() => {
        this.setTimeShare = true
      }, 100)
      // 获取详情对应的一级导航
      if(this.$store.getters.lang =='zh'){
        this.$store.getters.menu.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
          }
        })
      }else{
        this.$store.getters.menuEn.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
          }
        })
      }
    },
    methods:{
      // 跳转二级导航
      toUrl(path) {
        if (this.$router.currentRoute.path !== path) {
          this.$router.push(path);
        }
      },
      // 获取数据
      async toGetData() {
        let {data:{data}} = await getShowHd({
          id : this.$route.params.id,
        })
        console.log(data)
        if(!data){
          this.$router.push('/404');
        }
        this.dataObj = {
          id: data.id,
          // title : this.$store.getters.lang == 'en' ?val.showhdTitleEn:val.showhdTitle,
          title: data.showhdTitle,
          addTime: data.createTime,
          // detail : this.$store.getters.lang == 'en' ? this.updateImageUrl(data.goodsContentEn) : this.updateImageUrl(data.goodsContent)
          detail: this.updateImageUrl(data.showhdContent)
        }
      },
      // toGetData() {
      //   getActivityA1Detail({id:this.$route.params.id}).then((res) => {
      //     this.dataObj = res.data.data
      //   })
      // },
    }
  }
</script>

<style scoped lang="less">
  .Breadcrumb {
    width: 1380px;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 40px;
    padding-bottom: 60px;
  }
  .el-breadcrumb {
    font-size: 20px;
  }
  .el-breadcrumb__item{
    cursor: pointer;
  }

  body {
    background: #f6f6f6;
  }
  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }

  .wrap{
    width: 100%;
    margin: 0 auto;
    height: 100%;
  }
  /**/
  .container{
    width: 1380px;
    background: #FFFFFF;
    padding: 60px;
    margin: 0 auto 80px;
  }
  .container .main {
    line-height: 2;
    font-size: 16px;
    text-align: justify;
  }

  .container .main .h2 {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    line-height: 1;
  }

  .container .main .time{
    text-align: center;
    padding: 0 0 20px 0;
    margin-bottom: 20px;
    font-size: 16px;
    color: #999;
    margin-top: 18px;
    border-bottom: 1px solid #f1f1f1;
  }

  .navNews {
    padding:10px 15px 0px;
    .prev{
      margin-top: 5px;
      line-height: 40px;
    }
    a{ color: #666; }
    a:hover { color: #c30b02; }
  }

  .share{
    display: flex;
    align-items: center;
    padding: 20px 15px 0;
    span{
      margin-right: 6px;
    }
  }

  .file{
    display: flex;padding: 10px 15px 0;
    .text{
      i{
        color:#cf121c;
        font-size: 18px;
        margin-right: 4px;
      }
    }
    .list{
      display: flex;
      flex-direction: column;
      a{ color: #666; }
      a:hover { color: #c30b02; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Activity/A1/Detail.vue